import catalog from "../components/catalog";
import tags from "../components/tags";

document.addEventListener('DOMContentLoaded', _ => {
    catalog.init();
    tags.init();
});
